/**
 * This is an attempt to write cleaner code through meaningful variable names and decoupling of logic between the redux store and components.
 * - You may freely extend this file w/ more selectors for AB tests to help you better name test placements (A,B,C,etc) around the code base.
 * - The selector function should be of the type (state: AppState) => Boolean so that it may be used as:
 *      - a callback to react-redux useSelector, useSelector(cb), so that it is reactive within react components.
 *      - a simple function that accepts the state obj in other files where you might want to leverage it.
 * - Conventions:
 *      - the export should start with selectHydra*test-name* and end with something meaningful to a reader: selectHydraSrsaControl.
 *      - keep it organized by seperate your new selectors from prior selectors with a comment.
 *
 * see marty docs https://github01.zappos.net/pages/mweb/marty/guides/development/ab.html#ab-test-selectors
 */

import { AppState } from 'types/app';
import { isAssigned } from 'actions/ab';
import { HYDRA_MAFIA_AKAMAI } from 'constants/hydraTests';

export const selectIsHydraMafiaAkamai = (state: AppState) => isAssigned(HYDRA_MAFIA_AKAMAI, 1, state);
